import { useContext, useEffect } from 'react';
import { Platform } from 'react-native';
import { NavigationContext, NavigationRouteContext } from '@react-navigation/native';

const APP_TITLE = 'aSeller';

// Title shown in each screen header, keyed by route key (web only).
const routeTitles = {};

const formatTitle = (title) => (title ? `${title} - ${APP_TITLE}` : APP_TITLE);

// Used by NavigationContainer `documentTitle`, so navigation updates the browser tab with the header title instead of the route name.
export const documentTitleFormatter = (options, route) => formatTitle(routeTitles[route?.key] || options?.title);

const WebDocumentTitle = ({ title }) => {
  const navigation = useContext(NavigationContext);
  const route = useContext(NavigationRouteContext);
  const routeKey = route?.key;

  useEffect(() => {
    if (!routeKey || typeof title !== 'string' || !title) return;
    routeTitles[routeKey] = title;
    const applyTitle = () => (document.title = formatTitle(title));
    if (navigation?.isFocused?.()) applyTitle();
    // Screens kept mounted in the stack need the title restored when they regain focus.
    const unsubscribe = navigation?.addListener?.('focus', applyTitle);
    return () => {
      delete routeTitles[routeKey];
      if (unsubscribe) unsubscribe();
    };
  }, [navigation, routeKey, title]);

  return null;
};

export default Platform.OS === 'web' ? WebDocumentTitle : () => null;
